import { COLORS } from 'helpers/globals'

const button = {
  background: COLORS.primary,
  color: 'white',
  fontSize: '1.8rem',
  fontWeight: '400',
  textAlign: 'center',
  padding: '.7rem 2.5rem',
  borderRadius: '1rem'
}

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  projectTitleEdit: {
    fontSize: '2rem',
    padding: '.3rem !important',
    borderColor: `${COLORS.quaternary} !important`,
    display: 'block',
    transition: 'all 0.30s ease-in-out',
    background: 'white !important',
    '&:hover': { borderColor: `${COLORS.quaternary} !important` },
    '&:focus': { borderColor: `${COLORS.primary} !important` }
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1.5rem'
  },
  confirmButton: {
    ...button,
    marginRight: '2rem'
  },
  cancelButton: {
    ...button,
    background: COLORS.secondary
  }
}



// WEBPACK FOOTER //
// ./src/components/EditProjectTitle/style.js